import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  color: #e9ecef;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }

  h4 {
    color: #e9ecef;
    font-size: 18px;
    line-height: 30px;
    font-weight: 700;
  }

  span {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
  }
`;

export const BlockInstrucao = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0;

  h3 {
    color: #e9ecef;
    font-size: 16px;
  }

  p {
    margin-top: 20px;

    & + p {
      margin-top: 10px;
    }
  }
`;
